import { faChevronLeft, faTimes } from '@fortawesome/pro-light-svg-icons';

import { Icon } from '@/components/ui/icon.component';
import { SheetClose, SheetHeader, SheetTitle } from '@/components/ui/sheet';
import { removeRegistrationStorage } from '@/storage/registration.storage';
import { StepKeys } from '@/app/(main)/_components/sign-in-modal/_types/header-auth-modal-step-keys.enum';
import { useProgressiveModal } from '@/components/ui/progressive-modal/progressive-modal.hook';
import RegisterForm from '@/app/(main)/_components/sign-in-modal/_components/register-form.component';

export default function RegisterStep() {
  const { handleJump: jump } = useProgressiveModal<StepKeys>();
  const handleBack = () => {
    removeRegistrationStorage();
    if (jump) {
      jump({ key: StepKeys.LOGIN, returning: true });
    }
  };

  return (
    <div className="flex flex-col h-full overflow-x-visible -mx-5">
      <SheetHeader className="mb-5 px-5">
        <div className="flex justify-between gap-3 items-center">
          <div className="flex gap-3">
            <div className="flex justify-center w-[30px] h-[30px]">
              <Icon
                icon={faChevronLeft}
                className="cursor-pointer text-gray-500 text-base self-center"
                onClick={handleBack}
                data-testid="register-icon--back"
              />
            </div>
            <SheetTitle>
              <div className="flex gap-3">
                <span
                  className="font-extrabold text-2xl text-gray-900 text-nowrap"
                  data-testid="register-span--register-step"
                >
                  Cadastre-se
                </span>
              </div>
            </SheetTitle>
          </div>
          <SheetClose asChild className="text-gray-500 cursor-pointer self-center px-2 hover:bg-gray-50">
            <Icon icon={faTimes} size="xl" className="hover:text-gray-900 text-[1.625rem]" />
          </SheetClose>
        </div>
      </SheetHeader>
      <div className="flex flex-col h-full md:basis-[50vh] overflow-y-scroll px-5 -mb-5">
        <RegisterForm />
      </div>
    </div>
  );
}
